<template>
  <div v-if='isLoading'>
    <wc-loading :size='20' :width='1'></wc-loading>
  </div>
  <div v-else>
    <v-btn icon small @click="$emit('toggle')" :disabled='disabled'>
      <v-icon v-if='status && !indeterminate' :color='trueColor'>{{ trueIcon }}</v-icon>
      <v-icon v-if='!status && !indeterminate' :color='falseColor'>{{ falseIcon }}</v-icon>
      <v-icon v-if='indeterminate' :color='indeterminateColor'>{{ indeterminateIcon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'wc-checkbox',
  props: {
    status: {
      required: true,
      type: Boolean,
      default: false
    },
    indeterminate: {
      required: false,
      tpye: Boolean,
      default: false
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    trueColor: {
      required: false,
      default: 'info'
    },
    falseColor: {
      required: false
    },
    indeterminateColor: {
      required: false,
      default: 'info'
    },
    trueIcon: {
      required: false,
      default: 'mdi-checkbox-marked-outline'
    },
    falseIcon: {
      required: false,
      default: 'mdi-checkbox-blank-outline'
    },
    indeterminateIcon: {
      required: false,
      default: 'mdi-minus-box-outline'
    }
  }
}
</script>
